import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { grantLeaderboardAccess, hasLeaderboardAccess } from '../../utils/leaderboardAccess';
import { LEADERBOARD_ACCESS_CODE } from '../../config/constants';
import './LeaderboardAccessPage.css';

const LeaderboardAccessPage = () => {
  const [codeInput, setCodeInput] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!hasLeaderboardAccess(LEADERBOARD_ACCESS_CODE)) {
      return;
    }

    const nextPath = searchParams.get('next');
    navigate(nextPath || '/leaderboard', { replace: true });
  }, [navigate, searchParams]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const isValid = codeInput.trim().toLowerCase() === LEADERBOARD_ACCESS_CODE.toLowerCase();
    if (!isValid) {
      setError('Invalid access code.');
      return;
    }

    grantLeaderboardAccess(LEADERBOARD_ACCESS_CODE);

    const nextPath = searchParams.get('next');
    navigate(nextPath || '/leaderboard', { replace: true });
  };

  return (
    <div className="leaderboard-access">
      <div className="leaderboard-access__card">
        <h1 className="leaderboard-access__title">Secret Admin Access</h1>
        <p className="leaderboard-access__subtitle">Enter your access code to continue to secret tools.</p>
        <form className="leaderboard-access__form" onSubmit={handleSubmit}>
          <input
            type="password"
            className="leaderboard-access__input"
            value={codeInput}
            onChange={(event) => {
              setCodeInput(event.target.value);
              if (error) setError('');
            }}
            placeholder="Access code"
            autoComplete="off"
          />
          <button type="submit" className="leaderboard-access__button">
            Continue
          </button>
        </form>
        {error && <p className="leaderboard-access__error">{error}</p>}
      </div>
    </div>
  );
};

export default LeaderboardAccessPage;
